import { primitiveValue } from "@fusion-advantage/backcompat"
import { isConceptStatus } from "@fusion-advantage/formlib"
import { useConceptStatus, useConceptStatusValidity } from "../../../redux/selectConceptStatus2"
import L3ValueLabel from "../l3/L3ValueLabel"
import { useConceptValidator } from "./useConceptValidator"
import L1ErrorBlock from "../l1/L1ErrorBlock"

interface L4ValueLabelProps {
	cid?: string
	size?: 'max'
	colorByValidity?: boolean
	defaultValue?: string
}

const L4ValueLabel = ({cid, size, colorByValidity, defaultValue}: L4ValueLabelProps) => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4ValueLabel',
		cid,
		requireConcept: true,
	})
	const conceptStatus = useConceptStatus(cid)
	if(errorNode) {
		return errorNode
	}
	if(conceptStatus && !isConceptStatus(conceptStatus)) {
		// probably passed SuperconceptStatus instead of ConceptStatus
		// which doesn't make sense for this control
		return <L1ErrorBlock content={`[L4ValueLabel ${cid}] conceptStatus is incorrect type`} />
	}
	let value = conceptStatus?.value ?? defaultValue ?? null
	if(value) {
		const rPrimitive = primitiveValue(value)
		if(rPrimitive.isErr()) {
			return <L1ErrorBlock content={`[L4ValueLabel ${cid}] concept status value is not primitive`} />
		}
		value = rPrimitive.value
	}
	const validity = useConceptStatusValidity(cid)
	return (
		<L3ValueLabel
			size={size}
			colorByValidity={colorByValidity}
			value={value}
			validity={validity}
		/>
	)
}

export default L4ValueLabel
